(function(window, angular, undefined) {
angular.module('formApp')
.controller('covernoteCtrl', ['$scope', 'FormService', '$state', 'errorHandler', 'LoadingInterceptor', 'sessionService', '$location',
  function($scope, formService, $state, errorHandler, loadingInterceptor, sessionService, $location) {
    sessionService.stop();

    $scope.covernote = {};
    $scope.hasBrochure = false;
    $scope.bravError = false;

    var refNo = $location.search().RefNo;
    if (refNo) {
      $scope.covernote.bravRef = parseInt(refNo, 10);
    }
    if ($location.search().brochure === "true") {
      $scope.hasBrochure = true;
      //console.log("brochure", $scope.hasBrochure);
    }

    $scope.submit = function () {
      console.log("submit");
      var bravRef = $scope.covernote.bravRef;
      getBravDetails(bravRef);
      console.log("submit called");
    };

    $scope.noBravRef = function () {
      console.log("noBravRef");
      $scope.covernote.bravRef = parseInt("1300036477", 10);
    };

    function getBravDetails(bravRef) {
      console.log("getBravDetails function called");

      //removing existing campaign and brav from session storage
      sessionStorage.removeItem('campaign');
      sessionStorage.removeItem('brav');

      //loading interceptor
      loadingInterceptor.incrementRequests();

      //calling the service to get brav details
      formService.getBravDetails(bravRef).then(function (response) {
        var data = response.data;
        // keeping the retured brav in scope for validation and error handling
        $scope.brav = data.brav;
        console.log("getBravDetails response", response);
        //set brav and redirect based on response
        //Redirect only if vet or charity
        if (data.status === "success" && (data.recordType === "vet" || data.recordType === "charity")) {
          //set brav in session storage
          sessionStorage.setItem('brav', data.brav);
          sessionStorage.setItem('campaign', data.campaign);
          $state.go('step-1', { forward: true });
          loadingInterceptor.decrementRequests();
        }
        else {
          loadingInterceptor.decrementRequests();
          //set error message for showing the message
          $scope.bravError = true;
          document.getElementById('bravRef').focus();
        }
      }, function (error) {
        //error handling while getting brav details
        console.log("getBravDetails call failed", error);
        errorHandler.reportErrors(error, 'redirect');
      });
    }

}]);
})(window, window.angular);
